(() => {
 'use strict';
 const root=window.Shopify?.routes?.root||'/';
 if(/\/cart\/?$/.test(location.pathname))return;
 const english=document.documentElement.lang.toLowerCase().startsWith('en');
 const danish=document.documentElement.lang.toLowerCase().startsWith('da');
 const text=danish?{adding:'Dine billetter tilføjes …',opening:'Din kurv åbnes …',error:'Billetterne kunne ikke tilføjes. Prøv igen.'}:english?{adding:'Adding your tickets …',opening:'Opening your cart …',error:'Your tickets could not be added. Please try again.'}:{adding:'Tickets werden übernommen …',opening:'Dein Warenkorb wird geöffnet …',error:'Deine Tickets konnten nicht hinzugefügt werden. Bitte versuche es erneut.'};
 const appleTouch=/iPhone|iPad|iPod/.test(navigator.userAgent)||(/Macintosh/.test(navigator.userAgent)&&navigator.maxTouchPoints>1);
 let navigating=false,notice,transfer=null,pendingEntry=null,cancelled=false,rollingBack=false;
 // Create the eventual cart entry during the actual tap, before the app awaits
 // its requests. Keep the product URL until success. Replace this owned entry
 // with the cart instead of adding an async navigation that iOS may skip.
 function prepareHistory(event){
  if(!appleTouch||!event.isTrusted||pendingEntry||!/(?:^|\/)products\//.test(location.pathname))return;
  cancelled=false;
  try{
   const token=Date.now().toString(36)+Math.random().toString(36).slice(2);
   history.pushState({...history.state,tdtCartTransition:token},'',location.href);
   pendingEntry=token;
   
  }catch(_){pendingEntry=null;}
 }
 function rollbackHistory(){
  if(pendingEntry&&history.state?.tdtCartTransition===pendingEntry){rollingBack=true;history.back();}
  pendingEntry=null;
 }
 window.addEventListener('popstate',()=>{
  if(pendingEntry&&history.state?.tdtCartTransition!==pendingEntry){pendingEntry=null;cancelled=true;navigating=false;clearTransfer(false);}
  rollingBack=false;
 });
 const style=document.createElement('style');
 style.textContent='.tdt-cart-opening{position:fixed;inset:0;z-index:2147483647;background:#fff;display:grid;place-items:center;padding:24px;text-align:center;font:700 20px/1.4 Arial,sans-serif;color:#173451}.tdt-cart-opening[hidden]{display:none}';
 document.head.appendChild(style);
 function showOpening(message=text.opening){if(!notice){notice=document.createElement('div');notice.className='tdt-cart-opening';notice.setAttribute('role','status');notice.setAttribute('aria-live','polite');document.body.appendChild(notice);}notice.textContent=message;notice.hidden=false;}
 function clearTransfer(restore){if(restore)rollbackHistory();const current=transfer;transfer=null;if(current){clearTimeout(current.timer);current.button.removeAttribute('aria-busy');if(restore)current.modal?.classList.add('active');}if(!navigating&&notice)notice.hidden=true;}
 // Observe only the cart request started by this seat-selection click. Keep the
 // app's request, bundle payload and reservation logic intact.
 const originalFetch=window.fetch;
 window.fetch=function(input,options){
  const current=transfer;
  let observed=false;
  try{const url=new URL(typeof input==='string'?input:input.url,location.href);observed=!!current&&!current.requestStarted&&url.origin===location.origin&&/\/cart\/add\.js$/.test(url.pathname)&&String(options?.method||input?.method||'GET').toUpperCase()==='POST';}catch(_){}
  if(!observed)return originalFetch.apply(this,arguments);
  current.requestStarted=true;clearTimeout(current.timer);
  return Promise.resolve().then(()=>originalFetch.call(this,input,options)).then(response=>{
   if(!response.ok)throw new Error(text.error);
   current.timer=setTimeout(()=>{if(transfer===current)clearTransfer(true);},1500);
   return response;
  }).catch(error=>{if(transfer===current)clearTransfer(true);throw error;});
 };
 async function go(checkBenefit){
  if(navigating||cancelled)return;
  navigating=true;clearTransfer(false);showOpening();
  try{if(checkBenefit&&window.tdtReadTicketBenefit)await window.tdtReadTicketBenefit();}
  finally{
   if(!cancelled){
    
    if(pendingEntry&&history.state?.tdtCartTransition===pendingEntry)location.replace(root+'cart');
    else location.assign(root+'cart');
   }
  }
 }
 function capture(e){e.stopImmediatePropagation();e.preventDefault();go(true);}
 window.addEventListener('cart:open',capture,true);
 window.addEventListener('ajaxProduct:added',capture,true);
 window.addEventListener('click',e=>{
  const seat=e.target.closest('[data-smmodal-submit]');
  const purchase=e.target.closest('button,input[type=submit]');
  const button=seat||(purchase&&/^(In den Warenkorb|Add to cart|Tilføj til kurv)$/i.test((purchase.textContent||purchase.value||'').trim())?purchase:null);
  if(button&&!button.disabled&&!button.hasAttribute('disabled')&&button.getAttribute('aria-disabled')!=='true'){
   if(transfer||navigating||rollingBack){e.stopImmediatePropagation();e.preventDefault();return;}
   prepareHistory(e);
   const current={button,modal:button.closest('.seating-app-smmodal'),requestStarted:false};
   transfer=current;button.setAttribute('aria-busy','true');showOpening(text.adding);
   // A handler may reject the selection before making a request. Do not leave
   // an overlay over that validation message. Never abort an in-flight request.
   current.timer=setTimeout(()=>{if(transfer===current&&!current.requestStarted)clearTransfer(true);},1500);
  }
  const a=e.target.closest('a[href]');if(!a||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||a.target==='_blank'||a.hasAttribute('download'))return;
  const u=new URL(a.href,location.href);if(u.origin===location.origin&&/\/cart\/?$/.test(u.pathname)){e.stopImmediatePropagation();e.preventDefault();go(false);}
 },true);
 window.addEventListener('pageshow',()=>{pendingEntry=null;cancelled=false;rollingBack=false;navigating=false;clearTransfer(false);if(notice)notice.hidden=true;});
})();


